import { useState } from "react";
// import { useNavigate } from "react-router-dom";
import TrackerHistory from "../components/TrackerHistory";
import { IoMdSettings } from "react-icons/io";
import EditProfile from "../components/EditProfile";
import '../styles/profile.css';

function Profile() {
  const [isEditing, setIsEditing] = useState(false);
  // const navigate = useNavigate();

  const handleEditing = () => {
    setIsEditing(!isEditing);
  };

  return (
    <div className='container'>
      <h2 id="profile-header">
        Profile
        <IoMdSettings onClick={handleEditing} />
      </h2>

      {isEditing && (
        <EditProfile handleClick={handleEditing} />
      )}

      <TrackerHistory />
    </div>
  );
}

export default Profile;